import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from "react";
import { createNamedContext } from "../createNamedContext";
const UNKNOWN_BLOCK = "unknown";
export const BlockScopingContext = createNamedContext("BlockScopingContext", {
    block: UNKNOWN_BLOCK,
});
export const BlockScopingContextProvider = ({ block, nesting = false, children, }) => {
    const { block: parentBlock } = useContext(BlockScopingContext);
    const shouldNest = nesting && parentBlock !== UNKNOWN_BLOCK;
    const thisBlock = shouldNest ? `${parentBlock}:${block}` : block;
    return (_jsx(BlockScopingContext.Provider, { value: { block: thisBlock }, children: children }));
};
